(function () {
  function init(root) {
    if (!root || root.dataset.sigpReady === '1') return;
    root.dataset.sigpReady = '1';

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-sigp-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-sigp-panel]'));
    if (!tabs.length || !panels.length) return;

    var stage = root.querySelector('[data-sigp-stage]');
    var svg = root.querySelector('[data-sigp-connector]');
    var line = root.querySelector('[data-sigp-connector-line]');
    var dot = root.querySelector('[data-sigp-connector-dot]');
    var connectorOn = root.getAttribute('data-sigp-connector-on') === '1';

    function visiblePrimaryTab(id) {
      var matches = tabs.filter(function (tab) {
        return tab.getAttribute('data-sigp-tab') === id;
      });
      if (!matches.length) return null;
      var roleTab = matches.find(function (tab) {
        return tab.getAttribute('role') === 'tab' && tab.offsetParent !== null;
      });
      if (roleTab) return roleTab;
      return matches.find(function (tab) {
        return tab.offsetParent !== null;
      }) || matches[0];
    }

    function hubTarget() {
      var shared = root.querySelector('[data-sigp-hub] [data-sigp-hub-target]');
      if (shared) return shared;
      var active = root.querySelector('.sigp-panel.is-active [data-sigp-hub-target]');
      return active || null;
    }

    /* object-fit: contain letterboxing — use the real product silhouette, not the media box */
    function hubContentRect(hubEl) {
      var box = hubEl.getBoundingClientRect();
      var img = hubEl.matches('img') ? hubEl : hubEl.querySelector('img');
      if (!img || !img.naturalWidth || !img.naturalHeight || !box.width || !box.height) {
        return {
          left: box.left,
          top: box.top,
          right: box.right,
          bottom: box.bottom,
          width: box.width,
          height: box.height,
          cx: box.left + box.width / 2,
          cy: box.top + box.height / 2
        };
      }
      var scale = Math.min(box.width / img.naturalWidth, box.height / img.naturalHeight);
      var cw = img.naturalWidth * scale;
      var ch = img.naturalHeight * scale;
      var left = box.left + (box.width - cw) / 2;
      var top = box.top + (box.height - ch) / 2;
      return {
        left: left,
        top: top,
        right: left + cw,
        bottom: top + ch,
        width: cw,
        height: ch,
        cx: left + cw / 2,
        cy: top + ch / 2
      };
    }

    function updateConnector() {
      if (!connectorOn || !stage || !svg || !line || !dot) return;

      var activeId = null;
      var activeRole = root.querySelector('[role="tab"].is-active');
      if (activeRole) activeId = activeRole.getAttribute('data-sigp-tab');
      else {
        var any = root.querySelector('.sigp-card.is-active');
        if (any) activeId = any.getAttribute('data-sigp-tab');
      }
      var tab = activeId ? visiblePrimaryTab(activeId) : null;
      var hub = hubTarget();
      if (!tab || !hub) {
        svg.classList.remove('is-visible');
        line.setAttribute('d', '');
        return;
      }

      var stageRect = stage.getBoundingClientRect();
      var tabRect = tab.getBoundingClientRect();
      var content = hubContentRect(hub);
      if (!stageRect.width || !tabRect.width || !content.width) {
        svg.classList.remove('is-visible');
        return;
      }

      var w = stageRect.width;
      var h = stageRect.height;
      svg.setAttribute('viewBox', '0 0 ' + w + ' ' + h);
      svg.setAttribute('width', String(w));
      svg.setAttribute('height', String(h));

      var hubCx = content.cx - stageRect.left;
      var hubCy = content.cy - stageRect.top;
      var hubLeft = content.left - stageRect.left;
      var hubRight = content.right - stageRect.left;
      var hubTop = content.top - stageRect.top;
      var hubBottom = content.bottom - stageRect.top;

      var tabMidY = tabRect.top + tabRect.height / 2 - stageRect.top;
      var tabCenterX = tabRect.left + tabRect.width / 2 - stageRect.left;
      var fromLeft = tabCenterX < hubCx;
      var pad = 4;
      var startX = fromLeft ? tabRect.right - stageRect.left + pad : tabRect.left - stageRect.left - pad;
      var startY = tabMidY;

      /* Reach the product silhouette edge facing the active card */
      var edgeInset = 1;
      var endX = fromLeft ? hubLeft + edgeInset : hubRight - edgeInset;
      var endY = Math.max(hubTop + 10, Math.min(hubBottom - 10, tabMidY * 0.55 + hubCy * 0.45));

      var dx = endX - startX;
      if (Math.abs(dx) < 8) {
        svg.classList.remove('is-visible');
        return;
      }
      var pull = Math.min(96, Math.max(28, Math.abs(dx) * 0.45));
      var c1x = startX + (fromLeft ? pull : -pull);
      var c1y = startY;
      var c2x = endX - (fromLeft ? pull * 0.35 : -pull * 0.35);
      var c2y = endY;

      line.setAttribute('d', 'M ' + startX + ' ' + startY + ' C ' + c1x + ' ' + c1y + ', ' + c2x + ' ' + c2y + ', ' + endX + ' ' + endY);
      dot.setAttribute('cx', String(startX));
      dot.setAttribute('cy', String(startY));
      svg.classList.add('is-visible');
    }

    var connectorRaf = 0;
    function scheduleConnector() {
      if (!connectorOn) return;
      if (connectorRaf) cancelAnimationFrame(connectorRaf);
      connectorRaf = requestAnimationFrame(function () {
        connectorRaf = 0;
        updateConnector();
      });
    }

    function activate(id, focusTab) {
      tabs.forEach(function (tab) {
        var on = tab.getAttribute('data-sigp-tab') === id;
        tab.classList.toggle('is-active', on);
        if (tab.hasAttribute('aria-selected')) {
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
        }
        if (tab.hasAttribute('role') && tab.getAttribute('role') === 'tab') {
          tab.setAttribute('tabindex', on ? '0' : '-1');
          if (on && focusTab) tab.focus();
        }
      });
      panels.forEach(function (panel) {
        var on = panel.getAttribute('data-sigp-panel') === id;
        panel.classList.toggle('is-active', on);
        if (on) panel.removeAttribute('hidden');
        else panel.setAttribute('hidden', '');
      });
      scheduleConnector();
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        activate(tab.getAttribute('data-sigp-tab'), false);
      });
      tab.addEventListener('keydown', function (e) {
        var next = index;
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') next = (index + 1) % tabs.length;
        else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = tabs.length - 1;
        else return;
        e.preventDefault();
        activate(tabs[next].getAttribute('data-sigp-tab'), true);
      });
    });

    if (connectorOn) {
      window.addEventListener('resize', scheduleConnector);
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(scheduleConnector).catch(function () {});
      }
      root.querySelectorAll('img').forEach(function (img) {
        if (!img.complete) img.addEventListener('load', scheduleConnector, { once: true });
      });
      scheduleConnector();
      setTimeout(scheduleConnector, 120);
      setTimeout(scheduleConnector, 400);
    }
  }

  function boot() {
    document.querySelectorAll('[data-sigp-section]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target && e.target.querySelector('[data-sigp-section]');
    if (root) {
      delete root.dataset.sigpReady;
      init(root);
    }
  });
})();
